// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___3PzoX","label":"Editor__label___2EqG4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Label/Editor/Editor.scss
// module id = 989
// module chunks = 0